import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Local roles — no API call needed
export const AVAILABLE_ROLES = ['ADMIN', 'DEVELOPER', 'VIEWER'];

export interface UserToken {
  _id: string;
  user_id: string;
  token: string;
  is_active: boolean;
  created_at: string;
  __v: number;
  last_used: string;
}

export interface GenerateTokenResponse {
  token: UserToken;
}

export interface RevokeTokenResponse {
  message: string;
  userId: string;
}

export interface ValidateTokenResponse {
  valid: boolean;
  userId?: string;
  email?: string;
  expiresAt?: string;
}
@Injectable({ providedIn: 'root' })
export class UserService {
    private readonly baseUrl = '/api/iam';

    private readonly userUrl = `${environment.serverUrl}/api/users`;

    constructor(private http: HttpClient) { }

    getUsers(params: any): Observable<any> {
        const options = { params: new HttpParams({ fromObject: params }) };
        return this.http.get(environment.resourceUrl + "/users", options);
    }

    updateUser(id: string, body: any) {
        return this.http.put(environment.resourceUrl + `/users/${id}`, body);
    }

    createByAdmin(body: any, extra: any): Observable<any> {
        return this.http.post(`${environment.resourceUrl}/users/admin-create`, body);
    }

    getUserRoles(id: string): Observable<any> {
        return this.http.get(`${environment.resourceUrl}/users/${id}/roles`);
    }

    addUserRole(id: string, role: string): Observable<any> {
        return this.http.post(`${environment.resourceUrl}/users/${id}/roles`, { role });
    }

    removeUserRole(id: string, role: string): Observable<any> {
        return this.http.delete(`${environment.resourceUrl}/users/${id}/roles/${role}`);
    }

    getUserPermissions(id: string): Observable<any> {
        return this.http.get(`${environment.resourceUrl}/users/${id}/permissions`);
    }

    saveUserPermissions(id: string, permissions: string[], role: string,rolePermissions?: Record<string, string[]>): Observable<any> {
        return this.http.post(`${environment.resourceUrl}/users/${id}/permissions`, { permissions,role,role_permissions: rolePermissions });
    }
    resendInvite(userId: string): Observable<any> {
        return this.http.post(`${environment.resourceUrl}/users/${userId}/resend-invite`, {});
    }
    generateToken(userId: string): Observable<GenerateTokenResponse> {
    return this.http.post<GenerateTokenResponse>(
      `${this.baseUrl}/users/${userId}/generate-token`,
      {}
    );
  }

  revokeToken(userId: string): Observable<RevokeTokenResponse> {
    return this.http.put<RevokeTokenResponse>(
      `${this.baseUrl}/users/${userId}/revoke-token`,
      {}
    );
  }

  validateToken(): Observable<ValidateTokenResponse> {
    return this.http.get<ValidateTokenResponse>(
      `${this.baseUrl}/token/validate`
    );
  }
  getTokenByUser(userId: string): Observable<any> {
  return this.http.get<any>(`${this.baseUrl}/users/${userId}/token`);
}

  downloadImportSample() {
    return this.http.get(`${this.userUrl}/import-sample`, {
      responseType: 'blob'
    });
  }
}